import React, { useState, useEffect } from "react";
import { formatDateAndTime } from "../../utils/utils";
import styles from "./AccountDetail.module.css";
import { mcbGlobalAccount, mcbPartnerAccount } from "../../api";
import DataLoader from "../../Common/DataLoader/DataLoader";
import { Spinner } from "../../Common";
import { CookieUtils } from "../../axios.config";

const GlobalAccounts = ({ userId, apiType, onAccountId, onAccountStatus }) => {
  const [accountData, setAccountData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const clientName = CookieUtils.get("clientName");

  useEffect(() => {
    const getGlobalAccountData = async () => {
      try {
        setLoading(true);
        const response =
          apiType === "partner"
            ? await mcbPartnerAccount(userId)
            : await mcbGlobalAccount(userId);

        if (response?.status === 200) {
          setAccountData(response.data.data);
          if (onAccountId && response.data.data.accountId) {
            onAccountId(response.data.data.accountId);
          }
          if (onAccountStatus && response.data.data.status) {
            onAccountStatus(response.data.data.status);
          }
          setError(null);
        } else {
          setError(
            response?.data?.message || "Failed to fetch account details"
          );
        }
      } catch (err) {
        setError("Something went wrong while fetching account details");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    getGlobalAccountData();
  }, [userId, apiType]);

  if (loading) {
    return (
      <div className={styles.noData}>
        <Spinner />
      </div>
    );
  }

  if (error) {
    return <div className={styles.noData}>{error}</div>;
  }

  if (!accountData) {
    return (
      <div className={styles.noData}>
        {apiType === "partner"
          ? "No partner account data available"
          : "No global account data available"}
      </div>
    );
  }

  let accountDetails = [
    { label: "Account Type", value: accountData.accountType },
    { label: "Status", value: accountData.status },
    { label: "Branch Code", value: accountData.branchCode },
    { label: "Bank Code", value: accountData.bankCode },
    { label: "Created At", value: formatDateAndTime(accountData.createdAt) },
    { label: "Approved At", value: accountData.status === "APPROVED" ? formatDateAndTime(accountData.updatedAt) : "--",},
    // { label: "Submitted At", value: formatDateAndTime(accountData.user?.submittedAt) },
    // { label: "Approved At", value: formatDateAndTime(accountData.user?.approvedAt) },
  ];

  if (apiType === "partner") {
    accountDetails = accountDetails.filter(
      (item) => item.label !== "Account Type"
    );
  }
  
  let vendorDetails = [
    clientName === "STOCKAL" ? { label: "Vendor Account ID", value: accountData.vendorAccountId } : null,
    { label: "Account Number", value: accountData.vendorAccountNo },
    { label: "Bank Name", value: accountData.vendorBankName },
    { label: "Swift Code", value: accountData.vendorSwiftCode },
    { label: "Country", value: accountData.vendorCountry },
    { label: "State", value: accountData.vendorState },
    { label: "City", value: accountData.vendorCity },
    { label: "Address", value: accountData.vendorAddress },
  ];

  vendorDetails = vendorDetails.filter((item) => item !== null);
  if (apiType === "partner") {
    vendorDetails = vendorDetails.filter(
      (item) => item.label !== "Vendor Account ID"
    );
  }

  return (
    <DataLoader isLoading={loading} error={error}>
      <div className={styles.globalAccountContainer}>
        {/* <div className={styles.balanceSection}>
          <h3 className={styles.sectionTitle}>Balance Information</h3>
          <div className={styles.balanceCards}>
            <div className={styles.balanceCard}>
              <h4>Pending Balance</h4>
              <p>{accountData.pendingBalance || 0}</p>
            </div>
            <div className={styles.balanceCard}>
              <h4>Reserved Balance</h4>
              <p>{accountData.reservedBalance || 0}</p>
            </div>
            <div className={styles.balanceCard}>
              <h4>Hold Balance</h4>
              <p>{accountData.holdBalance || 0}</p>
            </div>
            <div className={styles.balanceCard}>
              <h4>Available Amount</h4>
              <p>{accountData.availableAmount || 0}</p>
            </div>
          </div>
        </div> */}
        <div className={styles.detailsRow}>
          <div className={styles.detailsSection}>
            <h3 className={styles.sectionTitle}>Account Information</h3>
            <table className={styles.detailsTable}>
              <tbody>
                {accountDetails.map((item, index) => (
                  <tr key={index}>
                    <td className={styles.labelColumn}>{item.label}:</td>
                    <td
                      className={
                        item.label === "Account ID"
                          ? styles.addressColumn
                          : styles.valueColumn
                      }
                    >
                      {item.value || "--"}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className={styles.detailsSection}>
            {/* <h3 className={styles.sectionTitle}>Vendor Information</h3> */}
            <table className={styles.detailsTable}>
              <tbody>
                {vendorDetails.map((item, index) => (
                  <tr key={index}>
                    <td className={styles.labelColumn}>{item.label}:</td>
                    <td
                      className={
                        item.label === "Vendor Address" ||
                        item.label === "Vendor Account ID"
                          ? styles.addressColumn
                          : styles.valueColumn
                      }
                    >
                      {item.value || "--"}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </DataLoader>
  );
};

export default GlobalAccounts;
